import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { StyledButton } from "../../../components/ListShowButton";

interface IApproveButton {
  id: number;
}

const CustomConfirmButton = ({ id }: IApproveButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [approve, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `subcontractorRouteTransactions/${id}/approve`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully approve route transaction.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed approve route transaction, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={approve}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const ApproveButton = ({ id }: IApproveButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      minWidth: 650,
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton
        variant="outlined"
        onClick={handleOpenDialog}
        style={{ color: "#4caf50", borderColor: "#4caf50" }}
      >
        Approve
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Approve The Route Transaction
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to approve the route transaction?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton id={id} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ApproveButton;
